import { CrmCustomerWorkbenchFeaturePage } from "..";

/** CRM 客户工作台路由页面。 */
export function CrmCustomerWorkbenchPage() {
  return <CrmCustomerWorkbenchFeaturePage />;
}
